module.exports = __webpack_public_path__ + "img/program-whiteboard.d55f4cd0.jpg";